import axios from "axios";

export interface FirebaseTokenResponse {
  firebase_token: string;
  expires_in: number;
}

export const postFirebaseToken = async (
  accessToken: string
): Promise<FirebaseTokenResponse> => {
  const URL = `${import.meta.env.VITE_API_BASE_URL}/auth/firebase-token`;

  const response = await axios.post<FirebaseTokenResponse>(
    URL,
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};
